import {createSelector} from "@reduxjs/toolkit";

export const selectGameById = (state, gameId) => {
    return state.sports.games[gameId];
}
export const selectGamesByIds = createSelector(
    (state, gameIds) => gameIds.map(gameId => selectGameById(state, gameId)),
    games => games.filter(x => !!x)
);
export const makeSelectGamesByIds = (gameIds) =>
    createSelector(
        (state) => state.sports.games,
        (gamesMap) => gameIds.map(id => gamesMap[id])
    );

export const selectPlayerById = (state, playerId) => {
    return state.sports.players[playerId];
}
export const selectPlayersByIds = createSelector(
    (state, playerIds) => playerIds.map(playerId => selectPlayerById(state, playerId)),
    players => players.filter(x=>!!x)
);
export const selectPlayerStatsById = (state, playerId, gameId) => {
    return state.sports.playersStats[playerId+"-"+gameId];
}
export const selectPlayersStatsByIds = (state, playerIdsGameIds) => {
    return playerIdsGameIds.map(playerIdGameId => selectPlayerStatsById(state, playerIdGameId));
}